import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Alert } from 'antd';

import withAuthentication from 'hoc/authentication';
import { getAllActivitiesDates } from 'helpers/activityHelpers';
import { readUserrequestParkings } from 'modules/userrequestParkings';
import List from './List';

export class ParkingsList extends React.PureComponent {
  static propTypes = {
    parkings: PropTypes.array,
    activities: PropTypes.arrayOf(PropTypes.shape({
      eventDates: PropTypes.arrayOf(PropTypes.shape({
        dates: PropTypes.array,
      })),
    })),
  };

  constructor (props) {
    super(props);
    const { isStaff } = props;
    if (isStaff) {
      props.readUserrequestParkings();
    }
  }

  getParkingsWithOccupation () {
    const { parkings, allParkings } = this.props;

    return parkings.map(parking =>
      allParkings.find(p => p.properties.id === parking.properties.id) || parking);
  }

  isAvailable (occupation = []) {
    const { activities, userrequestId } = this.props;

    return getAllActivitiesDates(activities)
      .reduce((available, { startDate: startDateStr, endDate: endDateStr, userrequest }) => {
        if (!available) return false;
        // Parking is occupied by current UR
        if (userrequest === userrequestId) return true;

        const startDate = new Date(startDateStr);
        const endDate = new Date(endDateStr);
        const isAvailable = occupation
          .reduce((occupationIsAvailable, {
            startDate: occupationStartDateStr,
            endDate: occupationEndDateStr,
          }) => {
            if (!occupationIsAvailable) return occupationIsAvailable;

            const occupationStartDate = new Date(occupationStartDateStr);
            const occupationEndDate = new Date(occupationEndDateStr);

            return !(occupationEndDate > startDate && occupationStartDate < endDate);
          }, true);
        return isAvailable;
      }, true);
  }

  render () {
    const { isStaff, parkings } = this.props;

    const { freeParkings, unfreeParkings } = !isStaff
      ? { freeParkings: parkings, unfreeParkings: [] }
      : this.getParkingsWithOccupation()
        .reduce((list, parking) => {
          const target = this.isAvailable(parking.properties.OCCUP)
            ? list.freeParkings
            : list.unfreeParkings;
          target.push(parking);
          return list;
        }, { freeParkings: [], unfreeParkings: [] });

    return (
      <React.Fragment>
        <List
          parkings={freeParkings}
        />
        {!!unfreeParkings.length && (
          <React.Fragment>
            <Alert
              type="warning"
              message={(
                <React.Fragment>
                  <p>
                    Les parkings suivants ne sont pas disponibles pendant les périodes d'une des
                    activités. <strong>Veuillez avertir le demandeur</strong> afin
                    qu'il choisisse un autre parking :
                  </p>
                  <List
                    parkings={unfreeParkings}
                  />
                </React.Fragment>
              )}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ userrequestParkings: { parkings: allParkings } }) => ({ allParkings });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ readUserrequestParkings }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withAuthentication(ParkingsList));



// WEBPACK FOOTER //
// ./src/components/Summary/ParkingsList/index.js